import React, {Fragment} from "react";
import _ from "lodash";
import moment from "moment";
import Pagination from "rc-pagination";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "rc-pagination/assets/index.css";
import { globals } from "../../../../common/constants";
import ReactTooltip from 'react-tooltip'

//components
import ColumnViewFilters from '../ColumnViewFilters';
import {CustomInputFilter} from "../CustomInput";

export default class Table extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      itemsPerPage: globals.casesPerPage,
      timeout: null,
      dateOfSubmission: "",
      sendingDate: "",
      dateOfReturn: "",
      showColumnFilter: false,
      focusedField: null
    };
    this.onPageChange = this.onPageChange.bind(this);
    this.handleFilter = this.handleFilter.bind(this);
  }

  handleFilter(fieldName, value) {
    const filterOptions = _.clone(this.props.filterOptions);
    filterOptions[fieldName] = value.toString().toLowerCase();
    clearTimeout(this.timeout);
    this.props.handleFilterDataChange(filterOptions);
    this.timeout = setTimeout(() => this.props.getFilteredDataRequest(), 300);
  }

  handleDatePicker = (date, name) => {
    const filterOptions = this.props.filterOptions;
    this.setState({ [name]: date });
    if (date !== null) {
      filterOptions[name] = date.format("YYYY-MM-DD");
    } else {
      filterOptions[name] = null;
    }
    clearTimeout(this.timeout);
    this.props.handleFilterDataChange(filterOptions);
    this.timeout = setTimeout(() => this.props.getFilteredDataRequest(), 250);
  };

  transformDate(date) {
    if (date){
      return moment(date);
    }
  }

  onPageChange = current => {
    this.props.handlePageChange(current);
  };

  handleRowChange = event => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  openSortFilters = e => {
    e.persist();
    this.setState({
      showColumnFilter: !this.state.showColumnFilter
    });
  }

  discardSortFilters = e => {
    e.stopPropagation();
    this.setState({
      showColumnFilter: false
    });
  }

  setFocusedField = fieldName => {
    if (!this.isMobile) {
      if (this.state.focusedField) {
        return this.setFocusedField(null);
      }
      return;
    }
    this.setState({ focusedField: fieldName });
  }

  get isMobile () {
    return document.body.clientWidth <= globals.NAV_MIDDLE;
  }

  render() {
    const {
      data,
      columns,
      isHeaderHidden,
      currentPage,
      totalNumber,
      pagination,
      filterOptions,
      columnShow,
      isAdmin
    } = this.props;
    const { itemsPerPage, showColumnFilter } = this.state;

    return (
      <div>
        <div className={`table__cases ${this.isMobile ? 'table__cases__mobile' : ''}`}>
          <table className={`table ${this.props.className}`}>
            {!isHeaderHidden ? (
              <thead>
                <tr>
                  {columns.map((item, index) =>
                    item.isSortable && (columnShow[item.key]) ? (
                      
                      <th className={`header-position ${item.name.replace(' ','_')}`} key={item.key + index}>
                        <div className="sorting">
                          <span className="th-name">{item.name}</span>
                          <div className="sorting__icons">
                            <button
                                onClick={() => this.props.handleSort(item.key, "ASC")}
                                className="btn-link sort-down"
                            >
                              <span className="kr kr-sorting-down" />
                            </button>
                            <button
                                onClick={() =>
                                    this.props.handleSort(item.key, "DESC")
                                }
                                className="btn-link sort-up"
                            >
                              <span className="kr kr-sorting-up" />
                            </button>
                          </div>
                        </div>
                      </th>
                    ) :  columnShow[item.key] && (<th className="header-position" key={"header" + item.key}>
                      <div
                        className="wrapper-column-view-filters" 
                        onClick={item.key === 'filter' ? this.openSortFilters : null}
                        >
                         {item.src ? (<div data-tip="Modify column view">
                               <span className="kr kr-filter filterIcon"/>
                                      <ReactTooltip place="top" type="light" effect="float"/>
                                      </div>)
                                      : <span className="th-name">{item.name}</span>}

                      </div>
                      {item.key === 'filter' ? (showColumnFilter && <ColumnViewFilters
                              isAdmin={isAdmin}
                              onDiscard={this.discardSortFilters}
                          />)
                      : null}
                    </th>
                    )
                  )}
                </tr>
              </thead>
            ) : null}
            <tbody>
              {!isHeaderHidden ? (
                <tr>
                  {columns.map((col, index) => {
                    return (columnShow[col.key]) && col.isFilterable && col.filterType === "date" ? (
                      <td key={"filter" + col.name}>
                        <div className='td-relative'>
                          <DatePicker
                              dateFormat="DD/MM/YYYY"
                            key={"input" + index}
                            className="report__data__filter"
                            selected={this.transformDate(
                                filterOptions[col.key]
                            )}
                            onChange={date =>
                              this.handleDatePicker(date, col.key)
                            }
                            name={col.key}
                            placeholderText={col.placeholder || `Search`}
                            onChangeRaw={this.handleRowChange}
                          />
                        </div>
                      </td>
                    ) :  ( columnShow[col.key]) && col.isFilterable && col.filterType !== "select" ? (
                      <td key={"filter_other" + col.name}>
                        <div>
                          <CustomInputFilter
                              input_name={col.key}
                              focused={this.state.focusedField === col.key}
                              focus={this.setFocusedField}
                              activeClassName={'active-field'}
                              blur={() => this.setFocusedField(null)}
                              placeholder={!this.isMobile ? col.placeholder || `Search` : ''}
                              changeFilterOptions={this.handleFilter}
                              defaultValue={this.props.filterOptions[Object.keys(this.props.filterOptions).filter(filter => filter === col.key)]}
                          />
                        </div>
                      </td>
                    ) : ( columnShow[col.key]) && col.filterType === "select" ? (
                      <td key={"filter_select" + col.name}>
                        <div className="fr-block">
                          <select
                              placeholder={"Select " + col.name}
                              key={"input" + index}
                              defaultValue={filterOptions[col.key]}
                              className={`filter__dropdown report__data__filter ${
                                  col.customClassName ? col.customClassName : ""
                              }`}
                              name={col.key}
                              onChange={({ target }) => this.handleFilter(target.name, target.value)}
                          >
                            <option value={""}>All</option>
                            {col.options.map(option => (

                                <option
                                    key={option.value}
                                    value={option.value.toLowerCase()}
                                >
                                  {option.label}
                                </option>
                            ))}
                          </select>
                        </div>
                      </td>
                    ) : ( columnShow[col.key]) && (
                            <td key={"filter" + col.name}/>
                          );
                  })}
                </tr>
              ) : null}
              {data.length ? (
                data.map((row, index) => {

                  return [
                    <tr key={row.id} className={`${(this.props.dropRowId && this.props.dropRowId === row.id) ? 'tr-mobile' : ''} ${row.status === "Pending" ? "pending-case" : ""}`}>
                      {columns.map((col, i) => (
                       (columnShow[col.key]) && (
                          <td
                            className={col.name ? "table-cell-size" : ""}
                            key={col.name}
                          >
                            {col.render(row[col.key], row)}
                            </td>
                        )
                      ))}
                    </tr>,
                    <tr key={`${row.id}_`} className='table_dropdown'>
                      {
                      this.props.dropDown && this.props.dropRowId === row.id &&
                      <Fragment>
                        <td colSpan={6} className="td-bordered">
                        {
                          data.map((row, index) => {
                            return (
                                <Fragment key={`row_${row.id}`}>
                                  {this.props.dropRowId === row.id && this.props.dropDownCol && this.props.dropDownCol.map((col, i) => (
                                          <div
                                              className="info__item"
                                              key={`col_${col.key}`}
                                          >
                                            <div>{col.name}</div>
                                            <div>{col.render(row[col.key], row)}</div>
                                          </div>

                                  ))}
                                </Fragment>
                            )
                          })
                        }
                        </td>
                      </Fragment>
                    }
                    </tr>
                  ];
                })
              ) : (
                  <tr>
                    <td className="text-center" colSpan={columns.length}>
                      No data to display
                  </td>
                  </tr>
                )}
            </tbody>
          </table>
        </div>
        {pagination && totalNumber > 0 ? (
          <Pagination
            locale={{ prev_page: 'prev', next_page: 'next'}}
            className="pagination__rc"
            showLessItems
            hideOnSinglePage
            onChange={this.onPageChange}
            current={currentPage}
            total={totalNumber}
            pageSize={itemsPerPage}
          />
        ) : null}
        <br />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Table/index.js